export default __webpack_public_path__ + "static/media/32-icon-more.d0e02ef3.svg";